export default __webpack_public_path__ + "static/media/avatar.f3ec1781.jpg";